import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  userType: string;
  admin: boolean;

  constructor() { }

  ngOnInit() {
   this.userType = localStorage.getItem('userType');
   if (this.userType === 'superadmin') {
     this.admin = true;
   } else {
    this.admin = false;
   }
  }


}
